import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=5c6d4f9a&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=5c6d4f9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d4f9a",
  null
  
)

export default component.exports